import { createApi } from '@reduxjs/toolkit/query/react';

// This is the shared RTK Query API instance. Use injectEndpoints in feature slices.
export const api = createApi({
  reducerPath: 'api',
  baseQuery: async () => ({ data: {} }), // Custom queryFn per endpoint
  tagTypes: ['Order', 'AiVariation', 'EawbWallet'],
  endpoints: () => ({}),
});
